import { User } from '../types/User';

export const getUserInitials = (user: User) => {
  const { firstName, lastName } = user;
  const firstInitial = firstName ? firstName[0] : '';
  const lastInitial = lastName ? lastName[0] : '';

  return `${firstInitial}${lastInitial}`.toUpperCase() || '?';
};
